export const BOT_ADAPTIVE_CARD_METADATA_KEY = 'microsoft.azure.communication.chat.bot.contenttype';
export const BOT_ADAPTIVE_CARD_METADATA_VALUE = 'azurebotservice.adaptivecard';
